import React from 'react';
import { getInputOptions } from '../../utils/getInputOptions';
import { chessFieldsNames } from '../constants/chessFieldsNames';
import { chessRequiredMsg } from '../constants/chessRequiredMsg';
import { validateToFields } from '../../utils/validators';
import LabelWithTooltip from '../components/LabelWithTooltip';
import TextField from '../../../../common/formComponents/TextField/TextField';
import styles from '../ChessForm.module.scss';

const {
  numberOfEntrances,
  numberOfFloors,
  numberOfFlats,
  fromFlatNumber,
  differentFloorEntrance,
  differentFloorNumOf,
  differentFlatNumOf,
  differentNumberOfFlatsEntrance,
  differentNumberOfFlatsFloor,
  differentNumberOfFlats,
  officeEntrance,
  officeFloor,
  numberOfOffices,
  isLoft,
  isBasement,
  isUndergroundParking,
  isGroundFloor,
  isOfficeFloor,
  isNumbering,
} = chessFieldsNames;

export const getChessFieldsData = ({
  initialValues,
  form,
  groundFloorDependentFields = [],
}) => {
  const firstRowFields = [
    {
      label: 'Количество подъездов',
      name: numberOfEntrances,
      options: getInputOptions({
        requiredErrMsg: chessRequiredMsg[numberOfEntrances],
        validationTypes: ['integer', 'zero'],
        initialValue: initialValues && initialValues[numberOfEntrances],
      }),
      span: 8,
      element: TextField,
    },
    {
      label: 'Количество этажей',
      name: numberOfFloors,
      options: getInputOptions({
        requiredErrMsg: chessRequiredMsg[numberOfFloors],
        validationTypes: ['integer', 'zero'],
        initialValue: initialValues && initialValues[numberOfFloors],
      }),
      span: 8,
      element: TextField,
    },
    {
      label: 'Кол-во квартир на этаже',
      name: numberOfFlats,
      options: getInputOptions({
        requiredErrMsg: chessRequiredMsg[numberOfFlats],
        validationTypes: ['integer', 'zero'],
        initialValue: initialValues && initialValues[numberOfFlats],
      }),
      span: 8,
      element: TextField,
    },
  ];

  const сhangeNumOfFloorsFields = [
    {
      label: 'Подъезд-исключение',
      name: differentFloorEntrance,
      options: getInputOptions({
        validationTypes: ['integer', 'zero'],
        initialValue: initialValues && initialValues[differentFloorEntrance],
      }),
      span: 7,
      element: TextField,
    },
    {
      label: 'Количество этажей',
      name: differentFloorNumOf,
      options: getInputOptions({
        validationTypes: ['integer', 'zero'],
        initialValue: initialValues && initialValues[differentFloorNumOf],
      }),
      span: 8,
      element: TextField,
    },
    {
      label: 'Кол-во квартир на этаже',
      name: differentFlatNumOf,
      options: getInputOptions({
        validationTypes: ['integer', 'zero'],
        initialValue: initialValues && initialValues[differentFlatNumOf],
      }),
      span: 9,
      withRemoveIcon: true,
      element: TextField,
    },
  ];

  const сhangeNumOfFlatsFields = [
    {
      label: 'Подъезд',
      name: differentNumberOfFlatsEntrance,
      options: getInputOptions({
        requiredErrMsg: chessRequiredMsg[differentNumberOfFlatsEntrance],
        validationTypes: ['integer', 'zero'],
        initialValue:
          initialValues && initialValues[differentNumberOfFlatsEntrance],
      }),
      span: 7,
      element: TextField,
    },
    {
      label: 'Этаж',
      name: differentNumberOfFlatsFloor,
      options: getInputOptions({
        form,
        requiredErrMsg: chessRequiredMsg[differentNumberOfFlatsFloor],
        validationTypes: ['integer', 'groundFloor'],
        initialValue:
          initialValues && initialValues[differentNumberOfFlatsFloor],
      }),
      span: 8,
      element: TextField,
    },
    {
      label: 'Количество помещений',
      name: differentNumberOfFlats,
      options: getInputOptions({
        requiredErrMsg: chessRequiredMsg[differentNumberOfFlats],
        validationTypes: ['integer', 'zero'],
        initialValue: initialValues && initialValues[differentNumberOfFlats],
      }),
      span: 9,
      withRemoveIcon: true,
      element: TextField,
    },
  ];

  const officeEntranceFields = [
    {
      label: 'Подъезд',
      name: officeEntrance,
      options: getInputOptions({
        requiredErrMsg: chessRequiredMsg[officeEntrance],
        validationTypes: ['integer', 'zero'],
        initialValue: initialValues && initialValues[officeEntrance],
      }),
      span: 7,
      element: TextField,
    },
    {
      label: 'Этаж',
      name: officeFloor,
      options: getInputOptions({
        form,
        requiredErrMsg: chessRequiredMsg[officeFloor],
        validationTypes: ['integer', 'groundFloor'],
        initialValue: initialValues && initialValues[officeFloor],
      }),
      span: 8,
      element: TextField,
    },
    {
      label: 'Кол-во офисов на этаже',
      name: numberOfOffices,
      options: getInputOptions({
        requiredErrMsg: chessRequiredMsg[numberOfOffices],
        validationTypes: ['integer', 'zero'],
        initialValue: initialValues && initialValues[numberOfOffices],
      }),
      span: 9,
      withRemoveIcon: true,
      element: TextField,
    },
  ];

  const fromFlatNumberFields = [
    {
      label: 'Заполнять дом с квартиры №',
      name: fromFlatNumber,
      options: getInputOptions({
        validationTypes: ['integer'],
        initialValue: initialValues && initialValues[fromFlatNumber],
      }),
      span: 24,
      inline: true,
      className: styles.fromFlatNumberInput,
      element: TextField,
    },
  ];

  const getSwitchInitialValue = (name) => {
    if (initialValues) {
      return initialValues[name];
    }

    return false;
  };

  const switchesFields = [
    {
      label: 'Чердак',
      name: isLoft,
      options: {
        initialValue: getSwitchInitialValue(isLoft),
      },
    },
    {
      label: 'Подвал',
      name: isBasement,
      options: {
        initialValue: getSwitchInitialValue(isBasement),
      },
    },
    {
      label: 'Подземный паркинг',
      name: isUndergroundParking,
      options: {
        initialValue: getSwitchInitialValue(isUndergroundParking),
      },
    },
    {
      label: 'Цокольный этаж',
      name: isGroundFloor,
      options: {
        initialValue: getSwitchInitialValue(isGroundFloor),
        rules: [
          {
            validator: validateToFields(form, groundFloorDependentFields),
          },
        ],
      },
    },
    {
      label: 'Офисный этаж',
      name: isOfficeFloor,
      options: {
        initialValue: getSwitchInitialValue(isOfficeFloor),
      },
    },
    {
      label: (
        <LabelWithTooltip
          label="Нумерация в доме"
          tooltipTitle="Активировать, если нумерация в доме не с квартиры №1"
        />
      ),
      name: isNumbering,
      options: {
        initialValue: getSwitchInitialValue(isNumbering),
      },
    },
  ];

  return {
    firstRowFields,
    сhangeNumOfFloorsFields,
    сhangeNumOfFlatsFields,
    officeEntranceFields,
    fromFlatNumberFields,
    switchesFields,
  };
};
